
import React from 'react'
import { Link } from 'react-router-dom'

import "./footer.css"

function Footer() {
    function scrollUp() {
    window.scrollTo({top: 0, behavior: "smooth"});
  }
    function scrollDown() {
    window.scrollTo({top: document.body.scrollHeight || document.documentElement.scrollHeight, behavior: "smooth"});
}
  return (
    <div className='footer'>
      <div className="top">
        <span className="top1"><h3>Members Online:</h3></span>
        <span className="top2">(<h4>2791 Members &nbsp;</h4> and <h4>&nbsp;6091 Guests &nbsp;</h4> online in &nbsp; <h4>last 5 minutes</h4>!)</span>
      </div>
      
      <div className="bottom" onClick={scrollUp} >(Go up)</div>
     
    </div>
  )
}

export default Footer